import { Mutator } from 'final-form';

// types
type DeliveryMutatorArg = {
  changedField: 'deliveryService' | 'region' | 'city' | 'warehouseType' | 'warehouse'
};

export const deliveryChangeMutator: Mutator = (
  args: DeliveryMutatorArg[],
  state,
  { changeValue },
) => {
  const { changedField } = args[0];

  if (changedField === 'deliveryService') {
    changeValue(state, 'region', () => undefined);
    changeValue(state, 'city', () => undefined);
    changeValue(state, 'warehouse', () => undefined);
    changeValue(state, 'paymentType', () => undefined);
  } else if (changedField === 'region') {
    changeValue(state, 'city', () => undefined);
    changeValue(state, 'warehouse', () => undefined);
  } else if (changedField === 'city') {
    changeValue(state, 'warehouseType', () => undefined);
    changeValue(state, 'warehouse', () => undefined);
  } else {
    changeValue(state, 'warehouse', () => undefined);
  }
};

export const deliverySellerChangeMutator: Mutator = (
  args: DeliveryMutatorArg[],
  state,
  { changeValue },
) => {
  const { changedField } = args[0];

  if (changedField === 'deliveryService') {
    changeValue(state, 'region', () => undefined);
    changeValue(state, 'city', () => undefined);
    changeValue(state, 'warehouseType', () => undefined);
    changeValue(state, 'warehouse', () => undefined);
  } else if (changedField === 'region') {
    changeValue(state, 'city', () => undefined);
    changeValue(state, 'warehouseType', () => undefined);
    changeValue(state, 'warehouse', () => undefined);
  } else if (changedField === 'city') {
    changeValue(state, 'warehouseType', () => undefined);
    changeValue(state, 'warehouse', () => undefined);
  } else {
    changeValue(state, 'warehouse', () => undefined);
  }
};
